module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("System ochrony ptaków na Farmy Wiatrowe")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bird Protection System for Wind Farms")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.$modal.show('video-static')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchVideo'))), _c('span')])])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Celem projektu jest stworzenie systemu, który w niezawodny sposób będzie wykrywał ptaki na farmach wiatrowych. Będzie on oparty na najnowszych technologiach, wykorzystywał stereoskopię i edge computing, a testy terenowe będziemy wykonywać na farmach wiatrowych, które należą do naszego partnera strategicznego PGE EO SA. Realizacja projektu trwa 3 lata i skończy się w 2021 r.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Tytuł projektu:"), _c('br'), _vm._v("\nRealizacja prac B+R, prowadzących do wdrożenia nowego rozwiązania - MULTIREJESTRATOR PLUS dla monitorowania i kontroli systemu elektroenergetycznego pod kątem efektywności eksploatacji, wydłużenia czasu życia i optymalizacji oddziaływania na otoczenie farm wiatrowych.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Cel projektu:"), _c('br'), _vm._v("\nCelem projektu jest przeprowadzenie prac B+R prowadzących do opracowania prototypu systemu radiowo wizyjnego, który pozwoli podnieść sprawność i wydajność pracy turbin wiatrowych.\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                4 109 660,41PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                3 021 687.62PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The aim of the project is to create a system that will reliably detect birds on wind farms. It will be based on the latest technologies, using stereoscopy and edge computing. We will perform field tests on wind farms that belong to our strategic partner PGE EO SA. The project will be implemented for 3 years and will end in 2021.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Project title:"), _c('br'), _vm._v("\nRealization of R&D works leading to the implementation of a new solution - MULTIREJESTRATOR PLUS for monitoring and control of the power system in terms of operational efficiency, the life span extending and optimizing the impact on the surrounding wind farms.\n  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                 The aim of the project is to carry out R&D works leading to the development of a radio and video prototype system that will improve the efficiency and performance of wind turbines, which will affect the growth of innovation in the national electricity sector. The project will be implemented by a qualified project team in 4 research tasks, the aim of which will be to design a complete vision system that allows the prediction of bird traffic near wind farms. The project will end with the creation of technical documentation enabling the implementation of MULTIREJESTRATOR PLUS technology on the market. It is planned to cover the results of R&D works with patent protection on the Polish, British and then European markets.\nMULTIREJESTRATOR PLUS will ensure uninterrupted or rarely interrupted work of wind farms, through the active protection of valuable bird species.\n                  "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                4 109 660,41PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                3 021 687.62PLN\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efd051fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BPS.vue
// module id = 313
// module chunks = 0